import React, { useEffect, useState } from "react";
import {
  interval,
  debounce,
  map,
  tap,
  filter,
  distinctUntilChanged,
} from "rxjs";
import eventEmitter from "../../eventEmitter";
import ImperativeTooltip from "./ImperativeTooltip";

function findTooltip(target) {
  const defaultDelay = 400;
  let node = target;

  while (node && node.hasAttribute) {
    if (node.getAttribute("data-tooltip")) {
      const delay = node.getAttribute("data-tooltip-delay") || defaultDelay;
      return { node, delay };
    }
    node = node.parentElement;
  }
  return {};
}

function TooltipRenderer() {
  const [anchor, setAnchor] = useState(null);

  useEffect(() => {
    const sub = eventEmitter.mouseOverTracker$
      .pipe(
        map(({ target }) => target),
        map(findTooltip),
        distinctUntilChanged((a, b) => a.node === b.node),
        tap(() => setAnchor(null)),
        filter(Boolean),
        debounce(({ delay }) => interval(delay || 0)),
        tap(({ node }) => setAnchor(node || null))
      )
      .subscribe(() => {});

    return () => sub.unsubscribe();
  }, []);

  if (!anchor) return null;

  return (
    <ImperativeTooltip
      anchor={anchor}
      onClose={() => setAnchor(null)}
      followMouse={Boolean(anchor.getAttribute("data-tooltip-follow-mouse"))}
      content={String(anchor.getAttribute("data-tooltip"))}
      isHtml={Boolean(anchor.getAttribute("data-tooltip-dangerous-html"))}
      className={anchor.getAttribute("data-tooltip-class") || "tooltip-default"}
      opacity={Number(anchor.getAttribute("data-tooltip-opacity")) || 1}
      zIndex={10005}
    />
  );
}

export default React.memo(TooltipRenderer);
